import { Evaluation } from "./evaluation";
import { Answer } from "./answer";

export interface EvaluationAthleteData {
  id?: number;
  status?: string;
  notes?: string;
  date?: any;
  athleteId?: number;
  coachId?: number;
  organizationId?: number;
  evaluationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  evaluation?: Evaluation;
  answers?: Answer[];
}

export class EvaluationAthlete {
  public static readonly STATUS_OPENED: string = 'opened';
  public static readonly STATUS_CLOSED: string = 'closed';
  public static readonly NUM_ITEMS: number = 10;

  public static getNonTranslatableFields(): string[] { return ['id', 'status', 'notes', 'date', 'athleteId', 'coachId', 'organizationId', 'evaluationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'status', 'notes', 'date', 'athleteId', 'coachId', 'organizationId', 'evaluationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  status?: string;
  notes?: string;
  date?: any;
  athleteId?: number;
  coachId?: number;
  organizationId?: number;
  evaluationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  evaluation?: Evaluation;
  answers?: Answer[];

  public static fromAPI(data: EvaluationAthleteData): EvaluationAthlete {
    if (data.evaluation) data.evaluation = Evaluation.fromAPI(data.evaluation);
    if (data.answers) data.answers = Answer.fromAPIList(data.answers);
    return new EvaluationAthlete(data);
  }

  public static fromAPIList(data: EvaluationAthleteData[]): EvaluationAthlete[] {
    return data.map((item: EvaluationAthleteData) => EvaluationAthlete.fromAPI(item));
  }

  constructor({id, status, notes, date, athleteId, coachId, organizationId, evaluationId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
                evaluation, answers} : EvaluationAthleteData) {
    this.id = id;
    this.status = status;
    this.notes = notes;
    this.date = date;
    this.athleteId = athleteId;
    this.coachId = coachId;
    this.organizationId = organizationId;
    this.evaluationId = evaluationId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.evaluation = evaluation;
    this.answers = answers;
  }

  public toJson(): EvaluationAthleteData {
    return {
      id: this.id,
      status: this.status,
      notes: this.notes,
      date: this.date,
      athleteId: this.athleteId,
      coachId: this.coachId,
      organizationId: this.organizationId,
      evaluationId: this.evaluationId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
    };
  }
}
